import { Button } from "@/components/ui/button";
import { downloadFile } from "@/api";
import { HardHat, Plus, Upload, Database, FileSpreadsheet, LogOut, Settings } from "lucide-react";
import { toast } from "sonner";

function MonthSelector({ months, currentKey, onSelectMonth }) {
  return (
    <select
      data-testid="month-selector"
      className="bg-slate-800 text-white text-sm font-semibold border border-slate-600 rounded-sm px-2 py-1"
      value={currentKey || ""}
      onChange={(e) => onSelectMonth(e.target.value)}
    >
      {!months.length && <option value="">Nessun mese</option>}
      {months.map((m) => <option key={m.key} value={m.key}>{m.key}</option>)}
    </select>
  );
}

function PresenceBadge({ others }) {
  if (!others.length) return null;
  return (
    <div data-testid="live-planners-badge"
      className="flex items-center gap-2 px-3 py-1 bg-emerald-900 border border-emerald-500 rounded-full text-xs font-semibold text-emerald-100">
      <span className="animate-pulse bg-emerald-400 rounded-full w-2 h-2" />
      Online: {others.join(", ")}
    </div>
  );
}

export default function PlannerHeader({ months, currentKey, onSelectMonth, onNewMonth, onImport, onMaster, onMenu, others, operator, onLogout }) {
  const exportMonth = () =>
    downloadFile(`/months/${encodeURIComponent(currentKey)}/export`, `${currentKey}.xlsx`)
      .then(() => toast.success("Export mese scaricato"));

  return (
    <header className="print-hide bg-slate-900 text-white px-4 py-2 flex items-center gap-3 flex-wrap sticky top-0 z-50">
      <div className="flex items-center gap-2 mr-2">
        <HardHat className="w-5 h-5" />
        <h1 className="text-base font-black tracking-tighter">PIANIFICAZIONE CANTIERI</h1>
      </div>
      <MonthSelector months={months} currentKey={currentKey} onSelectMonth={onSelectMonth} />
      <Button data-testid="new-month-button" size="sm" variant="outline"
        className="rounded-sm border-slate-500 text-white hover:bg-slate-700 hover:text-white"
        onClick={onNewMonth}>
        <Plus className="w-4 h-4 mr-1" /> Nuovo mese
      </Button>
      <Button data-testid="import-button" size="sm" variant="outline"
        className="rounded-sm border-slate-500 text-white hover:bg-slate-700 hover:text-white"
        onClick={onImport}>
        <Upload className="w-4 h-4 mr-1" /> Import XLSM
      </Button>
      <Button data-testid="master-data-button" size="sm" variant="outline"
        className="rounded-sm border-slate-500 text-white hover:bg-slate-700 hover:text-white"
        onClick={onMaster}>
        <Database className="w-4 h-4 mr-1" /> Anagrafiche
      </Button>
      <Button data-testid="menu-button" size="sm" variant="outline"
        className="rounded-sm border-slate-500 text-white hover:bg-slate-700 hover:text-white"
        onClick={onMenu}>
        <Settings className="w-4 h-4 mr-1" /> Menu
      </Button>
      {currentKey && (
        <Button data-testid="export-month-button" size="sm" variant="outline"
          className="rounded-sm border-slate-500 text-white hover:bg-slate-700 hover:text-white"
          onClick={exportMonth}>
          <FileSpreadsheet className="w-4 h-4 mr-1" /> Export mese
        </Button>
      )}
      <div className="ml-auto flex items-center gap-3">
        <PresenceBadge others={others} />
        <span data-testid="current-operator" className="text-xs text-slate-300">{operator}</span>
        <Button data-testid="logout-button" size="sm" variant="ghost"
          className="text-slate-300 hover:bg-slate-700 hover:text-white" onClick={onLogout}>
          <LogOut className="w-4 h-4" />
        </Button>
      </div>
    </header>
  );
}
